module.exports = fox._r("images/reg_right_urban.png", __webpack_public_path__ + "images/reg_right_urban.png");


//////////////////
// WEBPACK FOOTER
// ./images/reg_right_urban.png
// module id = 525
// module chunks = 2